import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectUser, checkAuthStatus } from "store/src/slices/auth-slice";
import { toast } from "sonner";
import { useSearchParams, useNavigate } from "react-router-dom";

export default function IntegrationsRedirect() {
    const user = useSelector(selectUser);
    const [searchParams] = useSearchParams();
    const code = searchParams.get("code");
    const state = searchParams.get("state");
    const navigate = useNavigate();

    const dispatch = useDispatch();

    useEffect(() => {
        if (!code) {
            navigate("/profile/integrations", { replace: true });
            return;
        }
        if (!user || !user.id) {
            navigate("/profile/integrations", { replace: true });
            return;
        }

        const connect = async () => {
            try {
                let provider = state;
                if (!provider) {
                    console.error("No provider state found");
                    return;
                }

                const backendUrl = `${import.meta.env?.VITE_BASE_URL}/connect/${provider}?directusUserId=${encodeURIComponent(user.id)}&code=${encodeURIComponent(code)}`;

                const resp = await fetch(backendUrl, {
                    method: "GET",
                    credentials: "include",
                    headers: {
                        "Accept": "application/json"
                    }
                });

                if (resp.ok) {
                    const data = await resp.json();
                    await dispatch(checkAuthStatus());
                    toast.success(data.message || `Successfully connected to ${provider === 'discord' ? 'Discord' : 'GitHub'}`);
                } else {
                    console.error(`${provider} connect failed`, resp.status);
                    toast.error(`Failed to connect to ${provider === 'discord' ? 'Discord' : 'GitHub'}`);
                }
            } catch (err) {
                console.error(`Error connecting ${state}`, err);
                toast.error(`An error occurred while connecting to ${state === 'discord' ? 'Discord' : 'GitHub'}`);
            } finally {
                navigate("/profile/integrations", { replace: true });
            }
        };

        connect();
    }, [code, state, user, navigate, dispatch]);

    return (
        <div className="p-6">
            <div className="flex items-center justify-center min-h-[200px]">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto mb-4"></div>
                    <p className="text-lg">Connecting {state === 'discord' ? 'Discord' : 'GitHub'}...</p>
                </div>
            </div>
        </div>
    );
}